import { render, staticRenderFns } from "./RequestResetPasswordForm.vue?vue&type=template&id=1891f83e"
import script from "./RequestResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./RequestResetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports